import { create } from 'zustand';

interface stepDataState {
  param: any;
  bindParam: any;
  origin: { data: any };
  result: { data: any };
  init: (data: any) => void;
  bind: (result: { data: any }) => void;
}

/**
  subMenu 상태관리
**/
export const myInfoDataStore = create<stepDataState>(set => ({
  param: { initialSeq: 0 },
  bindParam: (bind: any) =>
    set(state => ({
      ...state,
      param: { ...state.param, ...bind },
    })),
  origin: { data: null },
  result: { data: null },
  init: (data: any) =>
    set(state => ({
      ...state,
      result: { ...data },
      origin: { ...data },
    })),
  bind: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.result, ...data },
    })),
}));
